import React from 'react'
import Panel from 'muicss/lib/react/panel'
import Container from 'muicss/lib/react/container'
import RaisedButton from 'material-ui/RaisedButton'
import Form from 'muicss/lib/react/form'
import { TextField, SelectField } from 'redux-form-material-ui'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import MenuItem from 'material-ui/MenuItem'
import LinearProgress from 'material-ui/LinearProgress'
import CameraAlt from 'material-ui/svg-icons/image/camera-alt'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import Snackbar from 'material-ui/Snackbar'
import Avatar from '../BadgeHeroesComponents/Avatar'
import S3Uploader from '../S3Uploader'
import { updateProfile, editProfileInfo } from '../../actions'
import { getS3Url } from '../../utils/utils'


const styles = {
  avatar: {
    height: '200px',
    width: 'auto',
  },
  avatarContainer: {
    textAlign: 'center',
    position: 'relative',
    display: 'inline-block',
    margin: 'auto',
    width: '200px',
    height: '200px',
  },
  avatarWrapper: {
    textAlign: 'center',
  },
  floatingButton: {
    position: 'absolute',
    bottom: '10px',
    right: '10px',
  },
  progress: (progressVisible => ({
    display: (progressVisible ? 'block' : 'none'),
  })),
}

/* Vista*/
class EditProfile extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      completed: 0,
      progressVisible: false,
      updateImageSnackbarOpen: false,
      updateDataSnackbarOpen: false,
    }
  }
  componentDidMount() {
    this.props.editProfileInfo(this.props.id)
  }

  handleSnackbarClose = () => {
    this.setState({ updateImageSnackbarOpen: false, updateDataSnackbarOpen: false })
  }
  handlePreProcess = (file, next) => {
    this.setState({ progressVisible: true })
    next(file)
  }
  handleProgress = (percent, message) => {
    this.setState({ completed: percent })
    console.log(`Upload progress: ${percent}% ${message}`)
  }
  handleFinish = (response, fileName) => {
    const url = getS3Url(fileName)
    this.setState({ progressVisible: false,
      completed: 0,
      updateImageSnackbarOpen: true,
      image_url: url })
    console.log(`Upload finished: ${url}`)
  }
  handleError = (message) => {
    console.log(`Upload error: ${message}`)
  }

  _openFileDialog = () => {
    this.fileUpload.click()
  }

  handleUpdateProfile = (values) => {
    this.setState({ updateDataSnackbarOpen: true })
    this.props.updateProfile({ ...values, image_url: this.state.image_url, id: this.props.id })
  }
  render() {
    const { image_url, id, first_name, email, last_name, titles, title } = this.props
    return (
      <Container>
        <Panel className="modal-panel">
          <Form onSubmit={this.props.handleSubmit(this.handleUpdateProfile)}>
            <legend>Editar Perfil</legend>
            <div style={styles.avatarWrapper}>
              <div style={styles.avatarContainer}>
                <Avatar
                  image_url={this.state.image_url || image_url}
                  size={200}
                />
                <FloatingActionButton
                  containerElement="label"
                  onClick={this._openFileDialog} mini
                  style={styles.floatingButton}
                >
                  <CameraAlt />
                </FloatingActionButton>
                <S3Uploader
                  ref={(input) => { this.fileUpload = input }}
                  handleFinish={this.handleFinish}
                  handleProgress={this.handleProgress}
                  handlePreProcess={this.handlePreProcess}
                  handleError={this.handleError}
                  id={id}
                />
              </div>
            </div>
            <br />
            <Row>
              <Col xs="6" xs-offset="3">
                <LinearProgress
                  color="#f79410"
                  style={styles.progress(this.state.progressVisible)}
                  mode="determinate" value={this.state.completed}
                />
              </Col>
            </Row>
            <br />


            <Field
              name="first_name"
              floatingLabelText="Tu Nombre"
              component={TextField} fullWidth type="text" value={`${first_name} ${last_name}`}
            />
            <Field
              name="email"
              component={TextField} fullWidth
              floatingLabelText="Tu Email" type="email" value={email}
            />
            <Field
              name="title_id" fullWidth
              component={SelectField} floatingLabelText={titles.length>0 ? "Tu Título" : "¡No has ganado ningún título!"} value={title.id}
            >
              {titles.map(currentTitle =>
                <MenuItem
                  value={currentTitle.id}
                  key={currentTitle.id} primaryText={currentTitle.name}
                />,
              )}
            </Field>
            <div style={{ textAlign: 'center' }}>
              <RaisedButton
                type="submit"
                label="Guardar Cambios" primary style={{ textAlign: 'center' }}
              />
            </div>
          </Form>
        </Panel>
        <Snackbar
          open={this.state.updateImageSnackbarOpen}
          message={'Imagen actualizada correctamente'}
          action={'OK'}
          autoHideDuration={1500}
          onRequestClose={this.handleSnackbarClose}
        />
        <Snackbar
          open={this.state.updateDataSnackbarOpen}
          message={'Datos Actualizados Correctamente'}
          action={'OK'}
          autoHideDuration={1500}
          onRequestClose={this.handleSnackbarClose}
        />
      </Container>
    )
  }
}
EditProfile.propTypes = {
  image_url: React.PropTypes.string.isRequired,
  handleSubmit: React.PropTypes.func.isRequired,
  updateProfile: React.PropTypes.func.isRequired,
  editProfileInfo: React.PropTypes.func.isRequired,
  id: React.PropTypes.number.isRequired,
  email: React.PropTypes.string.isRequired,
  first_name: React.PropTypes.string.isRequired,
  last_name: React.PropTypes.string.isRequired,
  titles: React.PropTypes.arrayOf(React.PropTypes.shape({
    name: React.PropTypes.string.isRequired,
    id: React.PropTypes.number.isRequired,
  })).isRequired,
  title: React.PropTypes.shape({
    name: React.PropTypes.string.isRequired,
    id: React.PropTypes.number.isRequired,
  }).isRequired,
}

/* Lógica*/

const mapStateToProps = (state) => {
  const user_state = state.user
  return { ...state.user,
    initialValues: {
      first_name: `${user_state.first_name} ${user_state.last_name}`,
      email: user_state.email,
      title_id: user_state.title.id,
    },
  }
}

const mapDispatchToProps = dispatch => ({
  updateProfile: (values) => {
    const fullNameSplitted = values.first_name.trim().split(' ')
    const first_name = fullNameSplitted[0]
    const last_name = (fullNameSplitted.length > 1 ? fullNameSplitted[1] : '')
    return dispatch(updateProfile({
      first_name,
      last_name,
      image_url: values.image_url,
      id: values.id,
      email: values.email,
    }))
  },
  editProfileInfo: id => dispatch(editProfileInfo(id)),
})

const ReduxEditProfile = reduxForm({
  form: 'EditProfileForm',
})(EditProfile)


export default connect(mapStateToProps, mapDispatchToProps)(ReduxEditProfile)

// const ConnectedEditProfile = connect(mapStateToProps, mapDispatchToProps)(EditProfile)


// export default reduxForm({
//   form: 'EditProfileForm',
// })(ConnectedEditProfile)




// WEBPACK FOOTER //
// ./src/components/EditProfile/index.jsx